import { render, staticRenderFns } from "./cutdown.vue?vue&type=template&id=28e42e0a&scoped=true"
import script from "./cutdown.vue?vue&type=script&lang=js"
export * from "./cutdown.vue?vue&type=script&lang=js"
import style0 from "./cutdown.vue?vue&type=style&index=0&id=28e42e0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e42e0a",
  null
  
)

export default component.exports